import { loadStripe, Stripe, StripeError } from "@stripe/stripe-js";

export const STRIPE_LOAD_ERROR = "We couldn't load the secure payment form. Please disable any ad blocker or privacy tool for this page, then try again.";

let stripePromise: Promise<Stripe | null> | null = null;

/**
 * A client-side Stripe card error (declined, insufficient funds, etc.), user-caused rather than an unexpected failure
 */
export class StripeCardError extends Error {
    public readonly type: StripeError["type"];
    public readonly code?: string;
    public readonly declineCode?: string;

    constructor(error: StripeError) {
        super(error.message);
        this.name = "StripeCardError";
        this.type = error.type;
        this.code = error.code;
        this.declineCode = error.decline_code;
    }
}

export async function handleStripeErrors<T extends { error?: StripeError }>(stripeCall: () => Promise<T>) {
    const { error, ...rest } = await stripeCall();
    if (error) {
        if (error.type === "card_error") {
            throw new StripeCardError(error);
        }
        throw new Error(error.message);
    }
    return rest;
}

export async function getStripe() {
    if (!stripePromise) {
        stripePromise = (async () => {
            const key = (window as any).stripePublishableKey;

            if (!key) {
                return null;
            }

            const stripe = await loadStripe(key);
            if (!stripe) {
                stripePromise = null;
                throw new Error(STRIPE_LOAD_ERROR);
            }
            return stripe;
        })();
    }

    return await stripePromise;
}
